<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.leads.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="tables.leads.allFields"
                                        :activeFields.sync="tables.leads.fields"
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.leads.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.leads.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :itemsPerPageSelect="{
                                        values: [
                                            1, 5, 10, 20, 50, 100, 500, 1000,
                                            5000, 10000,
                                        ],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.leads.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.leads.rows"
                                    v-bind="tables.leads"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <button
                                                class="m-2 p-0 btn-export-table"
                                                @click="
                                                    downloadExportTable({
                                                        tableName: 'leads',
                                                    })
                                                "
                                            >
                                                <span class="block-icon">
                                                    <CIcon
                                                        :content="
                                                            $options.icons
                                                                .cilDataTransferDown
                                                        "
                                                    />
                                                </span>
                                                <span class="text">
                                                    {{ $t("export_to_csv") }}
                                                </span>
                                            </button>
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter v-if="tables.leads.total_pages > 0">
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.leads.page"
                                    :pages="tables.leads.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonBack from "£lement/ButtonBack";
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
export default {
    name: "TriggerLeadsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonBack,
        FilterFields,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                leads: {
                    fields: [
                        {
                            key: "id",
                            label: "#",
                            fixed: true,
                            sorter: true,
                            filter: false,
                            fixed: true,
                            active: true,
                            _filter: true,
                        },
                        {
                            key: "email",
                            label: "email",
                            sorter: true,
                            filter: true,
                            active: true,
                            _filter: true,
                        },
                        {
                            key: "first_name",
                            label: "name",
                            sorter: true,
                            filter: false,
                            active: true,
                            _filter: false,
                        },
                        {
                            key: "origin",
                            label: "origin",
                            sorter: false,
                            filter: true,
                            active: true,
                            _filter: true,
                        },
                        {
                            key: "created_at",
                            label: "creation_date",
                            sorter: true,
                            filter: false,
                            active: true,
                            _filter: false,
                        },
                        {
                            key: "status",
                            label: "status",
                            sorter: true,
                            filter: true,
                            active: true,
                            _filter: true,
                        },
                        {
                            key: "message",
                            label: "message",
                            sorter: true,
                            filter: true,
                            active: true,
                            _filter: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    orderField: "id",
                    rows: 10,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: false,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),

        title_page: function () {
            return this.$t("leads_received");
        },
        trigger_uuid: function () {
            return this.$route.params.trigger_uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "leads",
                url: `/trigger.api/leads/` + this.trigger_uuid,
                adapterFilters: this.adapterFiltersToUseDate,
            });

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
